const COMMENTS = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20avatar%20portrait%20of%20a%20young%20girl%20with%20pink%20hair%20and%20sparkling%20eyes%2C%20simple%20pastel%20circle%20frame%2C%20soft%20warm%20lighting%2C%20clean%20minimalist%20profile%20picture%20style&width=120&height=120&seq=avatar-user-01&orientation=squarish',
    name: '樱花漫迷',
    time: '2小时前',
    content: '香蕉漫画的韩漫分类真的超级全！终于找到了《反派千金的生存法则》全集，画质清晰而且下拉式阅读特别流畅，已经安利给所有追漫的朋友了！',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20avatar%20portrait%20of%20a%20young%20boy%20with%20spiky%20brown%20hair%20and%20determined%20expression%2C%20simple%20warm%20circle%20frame%2C%20soft%20lighting%2C%20clean%20minimalist%20profile%20picture%20style&width=120&height=120&seq=avatar-user-02&orientation=squarish',
    name: '热血漫小王',
    time: '5小时前',
    content: '日漫新番推荐太及时了！每周都来这里看人气排行更新，编辑推荐的榜单质量很高，帮我发现了好几部冷门神作，现在每天都要来刷一刷更新动态。',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20avatar%20portrait%20of%20a%20young%20woman%20with%20long%20black%20hair%20and%20gentle%20smile%2C%20simple%20elegant%20circle%20frame%2C%20soft%20warm%20lighting%2C%20clean%20minimalist%20profile%20picture%20style&width=120&height=120&seq=avatar-user-03&orientation=squarish',
    name: '国漫守护者',
    time: '1天前',
    content: '国漫板块越做越好了！《镖人》和《一人之下》的更新基本同步，支持国漫从阅读开始。期待平台收录更多优秀的国产漫画作品，让更多人看到国漫的进步。',
  },
];

function CommentCard({ comment }: { comment: typeof COMMENTS[0] }) {
  const [imgError, setImgError] = useState(false);

  return (
    <div className="bg-background-50 rounded-xl border border-background-200/70 p-5 md:p-6 cursor-default">
      <div className="flex items-center gap-3 mb-3">
        {!imgError ? (
          <img
            src={comment.avatar}
            alt={comment.name}
            className="w-10 h-10 rounded-full object-cover flex-shrink-0"
            onError={() => setImgError(true)}
          />
        ) : (
          <div className="w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center text-secondary-500 flex-shrink-0">
            <i className="ri-user-line"></i>
          </div>
        )}
        <div>
          <div className="text-sm font-medium text-foreground-800">{comment.name}</div>
          <div className="text-xs text-foreground-500">{comment.time}</div>
        </div>
      </div>
      <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{comment.content}</p>
    </div>
  );
}

import { useState } from 'react';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            漫友评论
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto">
            听听漫迷们怎么说，一起分享漫画阅读的快乐
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 max-w-[960px] mx-auto">
          {COMMENTS.map((comment, idx) => (
            <CommentCard key={idx} comment={comment} />
          ))}
        </div>
      </div>
    </section>
  );
}